function doesFileNameHaveImageExtension(fileName) {
  const desiredFileExtensions = [
    "png",
    "jpg",
    "jpeg",
    "bmp",
    "webp",
    "gif",
    "svg",
    "avif"
  ];
  return (
    desiredFileExtensions.indexOf(
      fileName
        ?.split(".")
        ?.pop()
        .toLowerCase()
    ) > -1
  );
}

export { doesFileNameHaveImageExtension };
